<script>
    export default {
        name: "FiltersGeneral",
        data() {
            return {
                activeFilters: {},
                layoutData: [],
                resetFilters: false,
                storeFilterKey: ''
            }
        },
        computed:{
            filtersGeneral() {
                return this.$store.state.filters.general;
            },
            filterStore() {
                return this.$store.state.filters[this.storeFilterKey];
            },
            layoutCategoryFilters() {
                if(!this.layoutData.length) return false;

                const excepted = [
                    this.filtersGeneral.delivery.systemName,
                    this.filtersGeneral.existence.systemName,
                    this.filtersGeneral.productDiscount.systemName,
                    this.filtersGeneral.manufacturer.systemName,
                    this.filtersGeneral.maxPrice.systemName,
                    this.filtersGeneral.minPrice.systemName,
                    this.filtersGeneral.region.systemName,
                    this.filtersGeneral.wholesale.systemName,
                ];

                return this.layoutData.filter(filter => excepted.indexOf(filter.systemName) < 0);
            },
            layoutDelivery() {
                return this.getFilterByName(this.filtersGeneral.delivery.systemName);
            },
            layoutExistence() {
                return this.getFilterByName(this.filtersGeneral.existence.systemName);
            },
            layoutDiscount() {
                return this.getFilterByName(this.filtersGeneral.productDiscount.systemName);
            },
            layoutManufacturer() {
                return this.getFilterByName(this.filtersGeneral.manufacturer.systemName);
            },
            layoutRegion() {
                return this.getFilterByName(this.filtersGeneral.region.systemName);
            },
            layoutWholesale() {
                return this.getFilterByName(this.filtersGeneral.wholesale.systemName);
            },
            manufacturersData() {
                const filter = this.layoutData.filter(item => {
                    return item.systemName === this.filtersGeneral.manufacturer.systemName
                });

                return !filter.length ? [] : filter[0].valuesData
            },
            regionsData() {
                const filter = this.layoutData.filter(item => {
                    return item.systemName === this.filtersGeneral.region.systemName
                });

                return !filter.length ? [] : filter[0].valuesData
            },
        },
        methods: {
            addFiltersToUrl(filters) {
                let [queryString, queryStringPrefix] = ['', '?'];
                for(let [key, value] of Object.entries(filters)) {
                    if(!value) continue;

                    if(!Array.isArray(value)) {
                        queryString += `${key}=${value}&`;
                    } else {
                        value.forEach((item, idx) => {
                            queryString += `${key}[]=${item}&`;
                        });
                    }
                }

                if(queryString) {
                    queryString = queryStringPrefix + queryString;
                }

                if(!queryString) {
                    window.history.pushState({title: 'Update filters url'}, '', window.location.pathname)
                } else {
                    window.history.pushState({title: 'Update filters url'}, '', queryString)
                }
            },
            createFiltersFromApi(data) {
                const filters = {};

                if(!Array.isArray(data) && !data.length) {
                    return filters;
                }

                data.forEach(filter => {
                    filters[filter.systemName] = filter.systemValue;
                });

                return filters;
            },
            filterChange() {
                this.setStoreFiltersToUrl();
            },
            getFilterByName(systemName) {
                if(!this.layoutData.length) return false;

                return this.layoutData.find(filter => filter.systemName === systemName);
            },
            getFiltersFromUrl() {
                let params = this.$route.query;
                const updated = {};

                for (let[key, value] of Object.entries(params)) {
                    if(!key || ! value) continue;

                    let keyUpdated = key.replace('[]','');

                    if(Array.isArray(value)) {
                        updated[keyUpdated] = [];
                        value.forEach(item => {
                            updated[keyUpdated].push(parseInt(item))
                        });
                    } else {
                        if(key.indexOf('[]') > -1) {
                            updated[keyUpdated] = [];
                            updated[keyUpdated].push(parseInt(value))
                        } else {
                            updated[keyUpdated] = value === 'true' ? 1 : parseInt(value);
                        }
                    }
                }

                return updated;
            },
            isAutocomplete(type) {
                return type === 'autocomplete';
            },
            isAutocompleteMultiple(type) {
                return type === 'autocompleteMultiple';
            },
            mergeUrlFilters() {
                const urlFilters = this.getFiltersFromUrl();
                const storeFilters = this.filterStore;

                for(let [key, value] of Object.entries(urlFilters)) {
                    storeFilters[key] = value;
                }

                const commitData = {
                    key: this.storeFilterKey,
                    value: storeFilters
                };

                this.$store.commit('setFilters', commitData);
            },
            setStoreFiltersToUrl() {
                if(this.storeFilterKey) {

                    this.addFiltersToUrl(this.$store.state.filters[this.storeFilterKey])
                }
            },
            stringToBoolean(str) {
                str += '';
                if(!str) {
                    return false;
                }

                return JSON.parse(str.toLowerCase());
            },
            stringToNumber(str) {
                return str * 1;
            },
            updateList() {
                this.$emit('update-list');
            }
        }
    }
</script>
